<template>
    <div class="all_1">
      <login_top></login_top>
      <div class="all_middle" :style="{background: 'url('+$store.state.Url+img+') no-repeat'}">
        <div class="login">
          <p class="log_p">账户登录</p>
          <div class="login_for">
            <span class="login_user"></span>
            <input type="text" placeholder="用户名" v-model="form.user_name">
            <div class="clear"></div>
          </div>
          <div class="login_for">
            <span class="login_pass"></span>
            <input type="password" placeholder="密码" v-model="form.pass">
            <div class="clear"></div>
          </div>
          <button @click="getlogin1">登 录</button>
          <div class="login_r">
            <span>还没有账号？</span>
            <p @click="$router.push({path:'/register'})">立即注册>></p>
            <div class="clear"></div>
          </div>
        </div>
      </div>
      <Pagetail></Pagetail>
    </div>
</template>

<script>
  import Pagetail from '../assembly/Pagetail'
  import login_top from '../assembly/login_top'
  import { getimage } from "../api/loginred";
    export default {
        name: "login",
      data(){
          return{
            form:{
              user_name:'',
              pass:'',
            },
            img:''
          }
      },
      mounted() {
        this.init()
      },
      components:{
          Pagetail,login_top
        },
        methods:{
          getlogin1(){
            this.$store.dispatch('Login',this.form).then(res=>{
              console.log('进入')
              this.$router.push('/')
              this.$message({
                message: '登录成功',
                type: 'success'
              });
              this.$store.dispatch('GetInfo').then(res=>{

              })
            })
          },
          init(){
            getimage({}).then(res=>{
              this.img = res.result.login_img
            })
          }
        }
    }
</script>

<style scoped lang="less">
  @import "./css/login";
  p{

  }
</style>



// WEBPACK FOOTER //
// src/components/login.vue